// extracted by mini-css-extract-plugin
export default {"container":"BasketEmpty-E3JB5__container","header":"BasketEmpty-uTLWO__header","text":"BasketEmpty-ST11w__text"};